import React from 'react'

export const RateIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={13}
      fill="none"
      {...props}
    >
      <path
        fill="#00AC5F"
        d="M7.008.41c0-.415-.283-.519-.606-.294L4.564 1.407c-.265.19-.26.467 0 .651L6.407 3.35c.318.22.601.115.601-.294V.41ZM5.893 12.875c3.253 0 5.893-2.633 5.893-5.878 0-3.244-2.634-5.872-5.899-5.878a.491.491 0 0 0-.485.484c0 .27.22.496.491.496a4.9 4.9 0 0 1 4.911 4.898 4.9 4.9 0 0 1-4.91 4.899A4.9 4.9 0 0 1 .981 6.997c0-1.642.809-3.089 2.034-3.965.237-.179.312-.45.167-.691-.144-.23-.473-.3-.728-.104C.965 3.309 0 5.02 0 6.997c0 3.245 2.64 5.878 5.893 5.878Z"
      />
      <path
        fill="#00AC5F"
        d="M5.264 9.734c.19 0 .353-.092.468-.27l2.64-4.144c.064-.116.14-.242.14-.37 0-.258-.232-.426-.475-.426-.144 0-.288.093-.398.26L5.24 8.622l-1.138-1.47c-.139-.184-.266-.23-.428-.23a.447.447 0 0 0-.445.455c0 .127.052.248.133.357l1.41 1.73c.145.19.3.27.491.27Z"
      />
    </svg>
  )
}

export const ClockIcon = ({color = '#0087FF', ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      fill="none"
      {...props}
    >
      <g fill={color} clipPath="url(#ClockIcon)">
        <path d="M5.893 11.994c3.253 0 5.893-2.687 5.893-5.997S9.146 0 5.893 0C2.64 0 0 2.687 0 5.997s2.64 5.997 5.893 5.997Zm0-1c-2.715 0-4.91-2.234-4.91-4.997S3.177 1 5.892 1c2.716 0 4.911 2.234 4.911 4.997s-2.195 4.998-4.91 4.998Z" />
        <path d="m8.25 7.61-2.865-.943a.402.402 0 0 1-.255-.517l1.24-3.764a.4.4 0 0 1 .51-.26c.214.071.324.293.252.51L6.02 6.017l2.486.818c.22.072.329.294.257.512a.398.398 0 0 1-.513.264Z" />
      </g>
      <defs>
        <clipPath id="ClockIcon">
          <path fill="#fff" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const CrossIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      fill="none"
      {...props}
    >
      <g fill="#E62B34" clipPath="url(#a)">
        <path d="M5.893 11.994c3.253 0 5.893-2.687 5.893-5.997S9.146 0 5.893 0C2.64 0 0 2.687 0 5.997s2.64 5.997 5.893 5.997Zm0-1c-2.715 0-4.91-2.234-4.91-4.997S3.177 1 5.892 1c2.716 0 4.911 2.234 4.911 4.997s-2.195 4.998-4.91 4.998Z" />
        <path d="M4.17 8.69c.185 0 .283-.065.433-.27l1.248-1.812h.023L7.122 8.42c.145.206.248.27.428.27.26 0 .456-.176.456-.428a.473.473 0 0 0-.11-.306l-1.45-2.017 1.462-2.022c.08-.106.11-.2.11-.312a.42.42 0 0 0-.434-.412c-.179 0-.294.07-.421.265l-1.208 1.81h-.029l-1.23-1.816c-.133-.188-.243-.259-.44-.259-.248 0-.45.2-.45.435 0 .13.029.212.121.341l1.387 1.94-1.474 2.07a.507.507 0 0 0-.098.306c0 .23.185.406.428.406Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const CupIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      fill="none"
      {...props}
    >
      <g fill="#6F6DE8" clipPath="url(#a)">
        <path d="m2.63 4.512.002.071C1.553 4.833.88 5.258.88 5.752c0 .787 1.733 1.4 4.095 1.4 2.356 0 4.09-.613 4.09-1.4 0-.585-.943-1.072-2.384-1.287.004-.28.216-.533.395-.837 1.77.333 2.864 1.105 2.868 2.118 1.155.056 1.854.72 1.854 1.787 0 1.122-.76 1.797-2.018 1.797h-.352c-.745 1.563-2.253 2.54-4.202 2.54h-.508C1.897 11.87 0 9.827 0 6.918V5.752c0-1.028 1.124-1.81 2.935-2.137-.155.252-.305.53-.305.897Zm2.088 6.46h.508c2.26 0 3.742-1.54 3.83-3.829-.857.57-2.296.909-4.081.909-1.787 0-3.228-.34-4.086-.91.086 2.295 1.563 3.83 3.829 3.83Zm5.226-4.054c0 .537-.064 1.044-.188 1.513h.024c.717 0 1.138-.34 1.138-.898 0-.514-.357-.84-.974-.887v.272ZM4.361 4.361c-.402.017-.779.054-1.124.109.001-.317.27-.6.46-.959.334-.037.688-.058 1.061-.06-.16.261-.354.539-.397.91Zm2.07-.831c-.153.247-.32.514-.351.864-.347-.033-.717-.05-1.105-.05.06-.284.307-.551.473-.889.345.011.674.036.983.075Z" />
        <path d="M3.88 2.837c0-.731-.644-1.139-.644-1.641 0-.28.07-.43.257-.687A.308.308 0 0 0 3 .141c-.263.335-.372.642-.372 1.016 0 .76.634 1.133.634 1.68 0 .542-.634.921-.634 1.675 0 .385.11.692.366 1.022a.31.31 0 0 0 .492-.374c-.18-.246-.251-.397-.251-.687 0-.491.645-.899.645-1.636Zm1.723 0c0-.731-.645-1.139-.645-1.641 0-.28.07-.43.257-.687a.308.308 0 0 0-.492-.368C4.46.476 4.35.783 4.35 1.157c0 .76.634 1.133.634 1.68 0 .542-.634.921-.634 1.675 0 .385.11.692.366 1.022a.31.31 0 0 0 .492-.374c-.18-.246-.251-.397-.251-.687 0-.491.645-.899.645-1.636Zm1.722 0c0-.731-.645-1.139-.645-1.641 0-.28.071-.43.257-.687a.308.308 0 0 0-.492-.368c-.263.335-.372.642-.372 1.016 0 .76.634 1.133.634 1.68 0 .542-.634.921-.634 1.675 0 .385.11.692.366 1.022a.31.31 0 0 0 .492-.374c-.18-.246-.251-.397-.251-.687 0-.491.645-.899.645-1.636Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const AttentionIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={13}
      height={11}
      fill="none"
      {...props}
    >
      <path
        fill="#808F94"
        d="M1.58 11h8.974c.984 0 1.58-.683 1.58-1.569 0-.272-.08-.556-.225-.81L7.416.793A1.534 1.534 0 0 0 6.067 0c-.532 0-1.053.266-1.349.793L.226 8.621C.069 8.88 0 9.159 0 9.43 0 10.317.596 11 1.58 11Zm.006-.909c-.405 0-.648-.313-.648-.666 0-.11.023-.249.087-.37l4.487-7.822a.622.622 0 0 1 .555-.307c.215 0 .429.093.55.307l4.487 7.828a.81.81 0 0 1 .093.364c0 .353-.255.666-.654.666H1.586Z"
      />
      <path
        fill="#808F94"
        d="M6.067 7.098c.278 0 .44-.162.445-.463l.081-3.051c.006-.296-.225-.516-.532-.516-.313 0-.533.215-.527.51l.075 3.057c.006.295.168.463.458.463Zm0 1.881c.335 0 .625-.266.625-.602a.61.61 0 0 0-.625-.602.614.614 0 0 0-.626.602c0 .33.29.602.626.602Z"
      />
    </svg>
  )
}

export const ArrowIcon = ({color = '#808F94', ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      fill="none"
      {...props}
    >
      <path
        fill={color}
        d="m6.225 2.11 3.656 3.674c.293.285.675.12.788-.3l1.314-4.87a.479.479 0 0 0-.6-.594L6.524 1.328c-.42.113-.593.488-.3.781ZM1.03 11.824l9.234-9.227a.602.602 0 1 0-.848-.857L.174 10.97a.613.613 0 0 0 0 .856.611.611 0 0 0 .855 0Z"
      />
    </svg>
  )
}

export const AttentionIcon2 = ({color = '#FFBD06', ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19}
      height={19}
      viewBox="0 0 19 19"
      fill="none"
      {...props}
    >
      <g clipPath="url(#AttentionIcon2)">
        <path fill={color} d="M9.5 19a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Z" />
        <path
          stroke="#fff"
          d="M9.5 18.703A9.203 9.203 0 1 0 9.5.297a9.203 9.203 0 0 0 0 18.406Z"
        />
        <path
          fill="#fff"
          d="M8.996 4.367a.594.594 0 0 1 1.007 0l4.869 7.786a.595.595 0 0 1-.504.909H4.631a.594.594 0 0 1-.504-.909l4.87-7.786Z"
        />
        <path
          stroke={color}
          strokeLinecap="round"
          strokeWidth={1.2}
          d="M9.5 7.62v1.694"
        />
      </g>
      <defs>
        <clipPath id="AttentionIcon2">
          <path fill="#fff" d="M0 0h19v19H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}